var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseShareControl',{attrs:{"text":"","retain-focus-on-click":"","icon-disabled":_vm.iconDisabled,"ripple":false,"color":"white"}},[_c('span',{staticClass:"context-menu-text-item"},[_vm._v("\n    "+_vm._s(_vm.$t('Context.short.socialShare'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }